var map = {
	"./template.betgalaxy": 1993,
	"./template.betgalaxy.tsx": 1993,
	"./template.betroyale": 1994,
	"./template.betroyale.tsx": 1994,
	"./template.default": 651,
	"./template.default.tsx": 651,
	"./template.fiestabet": 1995,
	"./template.fiestabet.tsx": 1995,
	"./template.puntcity": 1996,
	"./template.puntcity.tsx": 1996,
	"./template.questbet": 1997,
	"./template.questbet.tsx": 1997,
	"./template.ts": 728,
	"./template.volcanobet": 1998,
	"./template.volcanobet.tsx": 1998,
	"./template.wellbet": 1999,
	"./template.wellbet.tsx": 1999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2291;